export default __webpack_public_path__ + "static/media/TSI.3febb50d.png";